import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

export default {
  /**
  * 对账单下载列表查询
  * @param {string} turnPageShowNum
  */
  getTableData (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/statements/query`, params, {
      ...config,
      convertPageNumAndSize: true
    }, 'URLEncoded')
  },

  /**
  * 查询地址
  * @param {string} currentBusinessCode 10700700
  * @param {string} channel 1103
  */
  companyDetailManage (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/10700700_companyDetailManage.do`, params, {
      ...config
    }, 'URLEncoded')
  },

  /**
  * 获取别名alias
  */
  getAlias (params = {}, config = {}) {
    return api.get(`${NO_PREFIX_URL}/api/client/fund/info`, params, config)
  },

  /**
  * 下载
  */
  downloadStatementsFiles (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/statements/file`, params, {
      ...config,
      responseType: 'blob'
    }, 'URLEncoded')
  }
}
